import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Icon, Paper, Typography } from "@material-ui/core";
import { isNil, isObject } from "lodash";
import { useStyles as homeStyles } from "../items/HomeCardStyles";

// const GLASS_STYLE = {
//   background: "rgb(255 255 255 / 40%)",
//   borderRadius: "16px",
//   boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
//   backdropFilter: "blur(5px)",
//   WebkitBackdropFilter: "blur(5px)",
//   border: "1px solid rgba(255, 255, 255, 0.3)",
// };

const useStyles = makeStyles((theme) => ({
  card: {
    // ...GLASS_STYLE,
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "center",
    gap: 24,
    height: "100%",
    width: "100%",
    backgroundColor: "transparent",
  },
  statsIconFA: {
    fontSize: 36,
    color: theme.palette.primary.main,
    width: "auto",
    height: "auto",
    padding: 2,
  },
  infoContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
}));

export default function CardKpi(props) {
  const { data, cardSize } = props;

  const classes = useStyles();
  const classesHome = homeStyles({ cardSize });

  if (isNil(data) || isNil(data?.valor) || !isObject(data?.valor)) {
    return null;
  }

  const { icon, iconColor, value, valueColor, label, labelColor } = data?.valor;

  if (isNil(value)) {
    return null;
  }

  return (
    <Paper
      className={`${classes.card} ${classesHome.indCircleLabelCont}`}
      elevation={0}
    >
      <div className={classes.infoContainer}>
        <Typography
          variant="h5"
          color="textSecondary"
          style={{ color: labelColor || undefined }}
        >
          {label}
        </Typography>
        <Typography variant="h5" style={{ color: valueColor || undefined }}>
          {value}
        </Typography>
      </div>
      <Icon
        className={`${icon || "fas fa-question"} ${classes.statsIconFA}`}
        style={{
          color: iconColor || "inherit",
        }}
      />
    </Paper>
  );
}
